"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from "../../styles/clsx.js";
import classes from "./Image.module.css.js";
const Image = forwardRef(
  ({ className, alt, ...props }, ref) => (
    // biome-ignore lint/a11y/useAltText: The `alt` prop is marked as required.
    /* @__PURE__ */ jsx(
      "img",
      {
        alt,
        ref,
        className: clsx(classes.base, className),
        ...props
      }
    )
  )
);
Image.displayName = "Image";
export {
  Image
};
